/**
 * @file index.jsx
 * @author Daniel Aguirre
 * @description manage service state
 */

// Dependencies
import { useEffect, useState } from 'react';
import { OFFLINE, ONLINE } from '../constants';

function useServiceState({ name, getState }) {
  const [service, setService] = useState({
    name,
    state: OFFLINE
  });

  const onGetState = (message) => {
    const serviceCopy = { ...service };
    if (message === 'success') serviceCopy.state = ONLINE;
    setService(serviceCopy);
  };

  useEffect(() => {
    getState(onGetState);
  }, []);

  return service;
}

export default useServiceState;
